"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchVerifySignatureKey = void 0;
const fetchVerifySignatureKey = (api, progressId, body, url) => api.POST(url, body, {
    headers: {
        progressId,
    },
});
exports.fetchVerifySignatureKey = fetchVerifySignatureKey;
//# sourceMappingURL=resolver.js.map